import { render } from "./carruselComponente-3_ingles.vue?vue&type=template&id=361f654a&scoped=true"
import script from "./carruselComponente-3_ingles.vue?vue&type=script&lang=js"
export * from "./carruselComponente-3_ingles.vue?vue&type=script&lang=js"

import "./carruselComponente-3_ingles.vue?vue&type=style&index=0&id=361f654a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-361f654a"]])

export default __exports__